module.exports = __webpack_public_path__ + "static/media/step1.330ae018.png";